<template>
    <div>
        <headerY :year="year" @yearNum="yearNum"/>
        <div class="content">
            <p @click="choice('第一学期')" :class="act==0&&actYear==year?'act':''">第一学期</p>
            <p @click="choice('第二学期')" :class="act==1&&actYear==year?'act':''">第二学期</p>
        </div>
    </div>
</template>

<script>
import headerY from './headerY.vue'
import dayjs from "dayjs";
import * as utils from "../utils";
    export default {
        name:'year',
        components:{
            headerY
        },
        data() {
            return {
                year:dayjs().get('year'),
                act:undefined,
                actYear:undefined
            }
        },
        methods: {
            yearNum(v) {
            // console.log(v);
            this.year = v;
            // this.getShowDays();
        },
        choice(v){
            let obj = {}
            obj.index = 3
            this.actYear = this.year
            if (v == '第一学期') {
                this.act= 0
                obj.startDate = `${this.year -1}-08-15`
                obj.endDate = `${this.year}-02-15`
            }else{
                this.act = 1
                obj.startDate = `${this.year}-02-16`
                obj.endDate = `${this.year}-08-14`
            }
            this.$emit('year',obj)
        }
        },
    }
</script>

<style lang="scss" scoped>

.content{
    width: 100%;
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
    p{
        width: 120px;
        height: 30px;
        margin: 5px auto ;
        // margin-top: 5px;
        cursor: pointer;
        border-radius: 5px;
        &:hover{
            background-color: #409eff;
            color: #fff;
        }
    }
    .act{
       background-color: #409eff;
            color: #fff; 
    }
}

</style>